export default Object.freeze({
    apiKey: "AIzaSyD81gQNOqarwO1oo8NuQcnSezh5DgpwQlo",
    authDomain: "utsusemi-stg.firebaseapp.com",
    databaseURL: "https://utsusemi-stg-default-rtdb.firebaseio.com",
    projectId: "utsusemi-stg",
    storageBucket: "utsusemi-stg.appspot.com",
    messagingSenderId: "184742400393",
    appId: "1:184742400393:web:c2a012134bbae287335158",
    measurementId: "G-J8FVJR9XVD"
});
